import { useEffect, useState } from "react";
import { Col, Divider, FloatButton, Row } from "antd";
import useQuery from "../../../hooks/useQuery";
import GRBS from "../../IpEMR/Doctor/OrderSheet/GRBS";
import Vitals from "../../IpEMR/Doctor/OrderSheet/Vitals";
import { getOrderSheetApi } from "../../../services/orderSheet.services";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import FloatingRecorder from "../AiAssistant/FloatingRecorder";
import RecordModal from "../AiAssistant/RecordModal";
import { useContext } from "react";
import { UserContext } from "../../../context/UserContext";
import aiIcon from "../../../assets/dashboardIcons/aiIcon.svg";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";

function Monitoring() {
  const query = useQuery();
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});
  const [openAiModal, setOpenAiModal] = useState(false);
  const [showFloatingRecorder, setShowFloatingRecorder] = useState(false);
  const [aiResponse, setAiResponse] = useState(null);
  const { userDetails } = useContext(UserContext);
  const [refresh, setRefresh] = useState(null);
  const userRole = userDetails?.currRole || getCookie(Role);
  const refreshPage = () => setRefresh((prev) => !prev);
  async function getData() {
    try {
      const response = await getOrderSheetApi(query?.patient);

      setFormData(response?.data?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleProcessComplete = (responseData) => {
    setAiResponse(responseData);
    setShowFloatingRecorder(false);
    setOpenAiModal(true);
  };
  useEffect(() => {
    if (query?.patient) getData();
  }, [query?.patient, refresh]);

  return (
    <>
      {loading ? (
        <LoadingIndicator message={"Loading..."} />
      ) : (
        <>
          <Row gutter={[24, 24]} className="doctor-monitoring-row">
            <Col xs={24} md={12}>
              <Divider style={{ padding: "0 10%" }} orientation="left">
                Vitals
              </Divider>
              <Vitals formData={formData?.vitals} getData={getData} />
            </Col>
            <Col xs={24} md={12}>
              <Divider style={{ padding: "0 10%" }} orientation="left">
                GRBS Monitoring
              </Divider>
              <GRBS formData={formData?.grbs_monitoring} getData={getData} />
            </Col>
          </Row>{" "}
        </>
      )}

      {userRole === "Doctor" && (
        <FloatButton
          shape="circle"
          type="primary"
          className="ai-assistant-float"
          icon={<img src={aiIcon} alt="AI Icon" width={25} height={32} />}
          onClick={() => {
            setShowFloatingRecorder(true);
            // setShowTooltip(false);
          }}
        />
      )}
      {showFloatingRecorder && (
        <FloatingRecorder
          onProcessComplete={handleProcessComplete}
          onClose={() => {
            setShowFloatingRecorder(false);
          }}
          userDetails={userDetails}
        />
      )}

      {/* Modal with AI Response */}
      {openAiModal && aiResponse && (
        <RecordModal
          open={openAiModal}
          setOpen={setOpenAiModal}
          refreshPage={refreshPage}
          aiResponse={aiResponse}
          startInFormStep={true}
        />
      )}
    </>
  );
}

export default Monitoring;
